<template>
  <div id="admin-receipt_report">
    <!-- 繳款項目報表 -->
    <div
      id="areceipt_report"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="areceipt_report"
    >
      <div class="col-12 pt-2 table-style">
        <!-- 功能欄 -->
        <v-query-layout>
          <!-- 1 -->
          <v-label
            slot="ql1-text-1"
            for="query-keyword"
            LabText="篩選資料："
            Labbold="true"
          />
          <input
            id="query-keyword"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          >
          <v-label
            slot="ql1-text-2"
            LabText="選擇單位："
            Labbold="true"
          />
          <v-Dept
            slot="ql1-input-2"
            :DeptData="NewDeptId"
            @SelectDept="SelectDept"
          />
          <!-- 2 -->
          <v-label
            slot="ql2-text-1"
            for="select-status"
            LabText="選擇繳費項目狀態："
            Labbold="true"
          />
          <select
            id="select-status"
            slot="ql2-input-1"
            class="input-style"
            style="width: 200px;"
            v-model="Querydetail.FeeOrderStatus"
          >
            <option :value='ByteNull'>
              -請選擇-
            </option>
            <option
              v-for="FeeOrder in FeeOrderStatus"
              :key="FeeOrder.id"
              :value="FeeOrder.value"
            >
              {{ FeeOrder.text }}
            </option>
          </select>
          <v-label
            slot="ql2-text-2"
            for="select-paytype"
            LabText="選擇繳費方式："
            Labbold="true"
          />
          <select
            id="select-paytype"
            slot="ql2-input-2"
            class="input-style"
            v-model="Querydetail.PayType"
          >
            <option :value='ByteNull'>
              -請選擇-
            </option>
            <option
              v-for="PayTypes in PayType"
              :key="PayTypes.id"
              :value="PayTypes.value"
            >
              {{ PayTypes.text }}
            </option>
          </select>
          <!-- 3 -->
          <v-label
            slot="ql3-text-1"
            LabText="繳費時間(起)："
            Labbold="true"
          />
          <a-locale-provider
            slot="ql3-input-1"
            :locale="zhTW"
          >
            <a-date-picker
              size="large"
              @change="onPayDTStart"
              :format="dateFormat"
              v-model="timePayDTStart"
            />
          </a-locale-provider>
          <v-label
            slot="ql3-text-2"
            LabText="繳費時間(迄)："
            Labbold="true"
          />
          <a-locale-provider
            slot="ql3-input-2"
            :locale="zhTW"
          >
            <a-date-picker
              id="paydtend"
              size="large"
              @change="onPayDTEnd"
              :format="dateFormat"
              v-model="timePayDTEnd"
            />
          </a-locale-provider>
          <!-- 4 -->
          <v-label
            slot="ql4-text-1"
            for="query-feeitemid"
            LabText="收費項目編號："
            Labbold="true"
          />
          <input
            slot="ql4-input-1"
            id="query-feeitemid"
            class="input-style"
            type="text"
            v-model="Querydetail.FeeItemId"
          >
          <v-label
            slot="ql4-text-2"
            for="query-feeorderid"
            LabText="繳款項目編號："
            Labbold="true"
          />
          <input
            slot="ql4-input-2"
            id="query-feeorderid"
            class="input-style"
            type="text"
            v-model="Querydetail.FeeOrderId"
          >
          <!-- 5 -->
          <v-label
            slot="ql5-text-1"
            for="query-payorderId"
            LabText="繳費單號："
            Labbold="true"
          />
          <input
            slot="ql5-input-1"
            id="query-payorderId"
            class="input-style"
            type="text"
            v-model="Querydetail.PayOrderId"
          >
          <v-label
            slot="ql5-text-2"
            for="select-needreceipt"
            LabText="需要收據(是/否)："
            Labbold="true"
          />
          <select
            id="select-needreceipt"
            slot="ql5-input-2"
            class="input-style"
            v-model="Querydetail.NeedReceipt"
          >
            <option :value='ByteNull'>
              -請選擇-
            </option>
            <option
              v-for="NR in NeedReceipt"
              :key="NR.id"
              :value="NR.value"
            >
              {{ NR.text }}
            </option>
          </select>
          <div slot="qcbutton5">
            <v-button
              btn-text="查詢"
              btnOutline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
        </v-query-layout>
        <div style="display: flex; margin-left: 97px; margin-top: 1px;">
          <v-label
            slot="ql1-text-1"
            LabText="功能："
            Labbold="true"
          />
          <v-button
            btn-text="繳款項目選取作廢"
            title="作廢繳款項目"
            btnType="danger"
            @click.native="CheckManyFeeorderCancel"
            class="mr-2"
            slot="ql1-input-1"
          >
            <font-awesome-icon
              slot="icon"
              icon="times"
              size="sm"
            />
          </v-button>
          <v-button
            btn-text="匯出繳款項目統計報表"
            title="繳款項目統計報表"
            btnType="warning"
            @click.native="PostFeeorderDetailexport"
            slot="ql1-text-2"
            class="mr-2"
          >
            <font-awesome-icon
              slot="icon"
              icon="print"
              size="sm"
            />
          </v-button>
          <v-button
            btn-text="匯出退費印領清冊"
            title="退費印領清冊"
            btnType="warning"
            @click.native="PostFeeorderRefundexport"
            v-if="Querydetail.FeeOrderStatus == 4"
            class="mr-2"
            slot="ql1-input-2"
          >
            <font-awesome-icon
              slot="icon"
              icon="print"
              size="sm"
            />
          </v-button>
          <v-label
            for="query-page"
            LabText="筆數："
            Labbold="true"
            slot="ql2-text-1"
          />
          <v-page
            id="query-page"
            @RecPerPage="RecPerPage"
            slot="ql2-input-1"
          />
        </div>
        <hr>
        <!-- 表格資料 -->
        <template>
          <b-table
            id="b-table"
            hover
            small
            bordered
            responsive
            ref="selectableTable"
            selectable
            show-empty
            empty-text="目前無資料"
            style="position: relative;"
            :select-mode="selectMode"
            selected-variant="success"
            @row-selected="onRowSelected"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
          >
            <!-- 姓名(套特殊字型) -->
            <template v-slot:cell(UserName)="data">
              <span class="nukWord">
                {{ data.item.UserName }}
              </span>
            </template>
            <!-- 繳費狀態 -->
            <template v-slot:cell(FeeOrderStatus)="data">
              <div
                v-for="FeeOrder in FeeOrderStatus"
                :key="FeeOrder.id"
                :value="FeeOrder.value"
              >
                <div v-if="FeeOrder.value == data.item.FeeOrderStatus">
                  {{ FeeOrder.text }}
                </div>
              </div>
            </template>
            <!-- 處理狀態 -->
            <template v-slot:cell(ProcessStatus)="data">
              <div v-if="data.item.ProcessStatus === 0">
                無須處理
              </div>
              <div v-else-if="data.item.ProcessStatus === 1">
                未處理
              </div>
              <div v-else-if="data.item.ProcessStatus === 2">
                已處理
              </div>
            </template>
            <!-- 單位 -->
            <template v-slot:cell(ApplyDeptId)="data">
              <div
                v-for="Dept in AllDeptData"
                :key="Dept.id"
                :value="Dept.DeptId"
              >
                <div v-if="Dept.DeptId == data.item.ApplyDeptId">
                  {{ Dept.DeptName }}
                </div>
              </div>
            </template>
            <!-- 繳費金額 -->
            <template v-slot:cell(PayAmt)="data">
              {{ data.item.PayAmt + ' 元' }}
            </template>
            <!-- 繳費方式 -->
            <template v-slot:cell(PayType)="data">
              <div
                v-for="Pay in PayType"
                :key="Pay.id"
                :value="Pay.value"
              >
                <div v-if="Pay.value == data.item.PayType">
                  {{ Pay.text }}
                </div>
              </div>
            </template>
            <template v-slot:cell(NeedReceipt)="data">
              <span v-if="data.item.NeedReceipt === 0">
                {{ '否' }}
              </span>
              <span v-else>
                {{ '是' }}
              </span>
              <!-- <span>
                {{ data.item.NeedReceipt }}
              </span> -->
            </template>
            <!-- 繳款日期 -->
            <template v-slot:cell(PayDT)="data">
              {{ date(data.item.PayDT) }}
            </template>
            <!-- 功能 -->
            <template v-slot:cell(Actions)="data">
              <v-button
                btn-text="詳細"
                title="詳細資料"
                btnSize="sm"
                btnType="warning"
                @click.native="Details(data.item.FeeOrderId)"
                v-if="data.item.FeeOrderId !== ''"
              />
              <v-button
                class="ml-2"
                btn-text="退費"
                title="退費申請"
                btnSize="sm"
                btnType="danger"
                @click.native="Refund(data.item)"
                v-if="data.item.FeeOrderStatus === 3"
              />
              <v-button
                class="ml-2"
                btn-text="退費補印"
                title="退費補印"
                btnSize="sm"
                btnType="danger"
                @click.native="Refund(data.item)"
                v-if="data.item.FeeOrderStatus === 4"
              />
              <v-button
                class="ml-2"
                btn-text="作廢"
                title="作廢繳款項目"
                btnSize="sm"
                btnType="danger"
                @click.native="CheckFeeorderCancel(data.item.FeeOrderId)"
                v-if="data.item.FeeOrderStatus === 0"
              />
            </template>
            <!-- 表格選擇 -->
            <template v-slot:cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">選取</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">取消</span>
              </template>
            </template>
          </b-table>
          <br>
          <!-- 頁碼 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          />
        </template>
        <br>
      </div>
    </div>
    <!-- 作廢 modal -->
    <v-modal id="FeeorderCancel">
      <div slot="header">
        作廢繳款項目
      </div>
      <div slot="body">
        確認是否作廢此項目
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認"
          btnType="primary"
          @click.native="PostFeeorderCancel"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import moment from 'moment'
import vLabel from '@/components/Features/Label'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiFeeorderQuerydetail, apiFeeorderCancel, apiFeeorderDetailexport, apiFeeorderRefundexport } from '../../../Api/api'
import 'ant-design-vue/lib/date-picker/style/css'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
export default {
  components: {
    'v-modal': vModal,
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'selected', label: '選取', thClass: 'table-th' },
        { key: 'SerialNo', label: '#', stickyColumn: true, isRowHeader: true, thClass: 'table-th', variant: 'info' },
        { key: 'FeeOrderStatus', label: '繳費狀態', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'ProcessStatus', label: '處理狀態', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'ApplyDeptId', label: '單位', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'FeeItemId', label: '收費項目編號', thClass: 'table-th', sortable: true },
        { key: 'FeeItemName', label: '收費項目', stickyColumn: true, isRowHeader: true, thClass: 'table-th', sortable: true, variant: 'info' },
        { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th', sortable: true },
        { key: 'UserName', label: '繳款人姓名', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'FeeOrderDesc', label: '事由', thClass: 'table-th' },
        { key: 'PayAmt', label: '繳費金額', thClass: 'table-th', sortable: true, sortDirection: 'desc', variant: 'warning' },
        { key: 'PayOrderId', label: '繳費單號', thClass: 'table-th', sortable: true },
        { key: 'PayType', label: '繳費方式', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'NeedReceipt', label: '需要收據(是/否)', thClass: 'table-th', sortable: true },
        { key: 'ReceiptDebt', label: '入帳收據號碼', thClass: 'table-th' },
        { key: 'ReceiptFormal', label: '正式收據編號', thClass: 'table-th' },
        { key: 'PayDT', label: '繳款日期', thClass: 'table-th', sortable: true, sortDirection: 'desc' },
        { key: 'RefundId', label: '退費單號', thClass: 'table-th' },
        { key: 'Actions', label: '功能', thClass: 'table-th' }
      ],
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      Querydetail: {
        DeptId: '',
        FeeItemId: '',
        FeeOrderId: '',
        PayDTStart: '',
        PayDTEnd: '',
        PayType: null,
        FeeOrderStatus: null,
        PayOrderId: '',
        NeedReceipt: null
      },
      Cancel: { // 單筆作廢
        Data: []
      },
      AllDeptData: [], // 部門資料
      NewDeptId: sessionStorage.getItem('ReportDeptID') ? JSON.parse(sessionStorage.getItem('ReportDeptID')) : '',
      FeeOrderStatus: [
        { value: '0', text: '未繳費' },
        { value: '1', text: '已列印繳費單' },
        { value: '2', text: '已繳費' },
        { value: '3', text: '已入帳' },
        { value: '4', text: '已申請退費' },
        { value: '5', text: '已退費完成' },
        { value: '255', text: '已作廢' }
      ],
      PayType: [
        { value: '0', text: '未繳費' },
        { value: '1', text: '國內信用卡' },
        { value: '2', text: '國外信用卡' },
        { value: '3', text: '一卡通' },
        { value: '4', text: 'LINE Pay' },
        { value: '5', text: 'WebATM(收到入金明細後更新)' },
        { value: '6', text: '四大超商繳款(收到繳款通知後更新)' },
        { value: '7', text: '土銀臨櫃繳款(收到入金明細後更新)' },
        { value: '8', text: '出納組現金繳納' },
        { value: '253', text: '已跳轉WebATM' },
        { value: '254', text: '列印繳費單(無條碼，尚未實際繳費)' },
        { value: '255', text: '列印繳費單(有條碼，尚未實際繳費)' }
      ],
      NeedReceipt: [
        { value: 0, text: '否' },
        { value: 1, text: '是' }
      ],
      QueryData: {},
      ByteNull: null,
      Backend: false,
      timePayDTStart: undefined,
      timePayDTEnd: undefined,
      errfunction: 0
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () { // 從Dept組件接收部門資料
    this.$bus.$on('AllDept', (data) => {
      this.AllDepts(data)
    })
  },
  mounted () {
    this.PostFeeorderQuerydetail()
  },
  methods: {
    moment,
    AllDepts (data) { // 從Dept組件取得部門資料
      if (this.errfunction === 0) {
        this.AllDeptData = data
        this.errfunction = 1
      }
    },
    SelectDept (vDeptId) { // 組件-部門
      this.NewDeptId = vDeptId
      sessionStorage.setItem('ReportDeptID', JSON.stringify(vDeptId))
    },
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    date (data) { // 時間參數過濾掉-時分秒
      var date
      if (data !== null) {
        date = data.substr(0, 10)
      }
      return date
    },
    onPayDTStart (date, dateString) { // 選擇建立時間(起)
      this.timePayDTStart = date
      this.Querydetail.PayDTStart = dateString
    },
    onPayDTEnd (date, dateString) { // 選擇建立時間(迄)
      this.timePayDTEnd = date
      this.Querydetail.PayDTEnd = dateString
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected (items) { // 表格選擇功能(1)
      this.selected = items
    },
    unselectThirdRow (data) { // 表格選擇功能(2)
      this.$refs.selectableTable.unselectRow(data)
    },
    PostFeeorderQuerydetail () { // 查詢明細 B_API 014
      // 定義資料
      var NewData
      const vm = this
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      // 查詢條件
      const ReceiptrQuery = JSON.parse(sessionStorage.getItem('ReceiptrQuery'))
      // 判斷帳號身分
      const Backend = md5('管理者')
      if (!ReceiptrQuery) { // 無查詢條件紀錄
        // 判斷帳號權限管理 & 業務，管理 = 全部門，業務 = 自己部門
        if (Backend === sessionStorage.getItem('Backend')) { // 管理
          vm.Backend = true
          vm.Querydetail.DeptId = ''
        } else {
          vm.Querydetail.DeptId = UserData.DeptId
        }
        vm.QueryData = {}
        vm.QueryData = vm.Querydetail // 部門ID

        // 預設繳費時間(起) = 兩個月前
        const twoMonthsBefore = moment().subtract(2, 'months').format(vm.dateFormat)
        vm.timePayDTStart = moment(twoMonthsBefore, vm.dateFormat)
        vm.Querydetail.PayDTStart = twoMonthsBefore

        // 預設繳費時間(迄) = 今天
        const today = moment().format(vm.dateFormat)
        vm.timePayDTEnd = moment(today, vm.dateFormat)
        vm.Querydetail.PayDTEnd = today

        sessionStorage.setItem('ReceiptrQuery', JSON.stringify(vm.QueryData)) // 記錄此次查詢條件
        NewData = Object.assign(IdentityData, vm.QueryData) // 組合API Data + 查詢條件
      } else { // 有查詢條件紀錄
        if (Backend === sessionStorage.getItem('Backend')) {
          vm.Backend = true
        }
        vm.Querydetail = ReceiptrQuery
        // 時間套件 = 判斷查詢紀錄時間是否空值，是 = undefined，否 = 在繳費時間欄位呈現時間資料
        vm.timePayDTStart = (ReceiptrQuery.PayDTStart === 'undefined' || ReceiptrQuery.PayDTStart === undefined || ReceiptrQuery.PayDTStart === '') ? undefined : moment(ReceiptrQuery.PayDTStart, vm.dateFormat)
        vm.timePayDTEnd = (ReceiptrQuery.PayDTEnd === 'undefined' || ReceiptrQuery.PayDTEnd === undefined || ReceiptrQuery.PayDTEnd === '') ? undefined : moment(ReceiptrQuery.PayDTEnd, vm.dateFormat)
        NewData = Object.assign(IdentityData, ReceiptrQuery)
      }
      // 呼叫API
      apiFeeorderQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              const json = res.Data[i]
              json.SerialNo = i + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
      this.CheckQueryDept()
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      var NewData
      const vm = this
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      // 業務身分，單位固定
      if (!vm.Backend) { // 業務
        vm.Querydetail.DeptId = UserData.DeptId
      } else {
        if (this.NewDeptId) {
          vm.Querydetail.DeptId = this.NewDeptId.DeptId
        }
      }
      NewData = Object.assign(IdentityData, vm.Querydetail)
      // 紀錄查詢條件
      vm.QueryData = {}
      vm.QueryData = vm.Querydetail
      sessionStorage.setItem('ReceiptrQuery', JSON.stringify(vm.QueryData))
      // 呼叫API
      apiFeeorderQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              const json = res.Data[i]
              json.SerialNo = i + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
      this.CheckQueryDept()
    },
    ClearCondition () { // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('ReceiptrQuery')
      sessionStorage.removeItem('ReportDeptID')
      vm.NewDeptId = ''
      vm.Querydetail = {
        DeptId: '',
        FeeItemId: '',
        FeeOrderId: '',
        PayDTStart: '',
        PayDTEnd: '',
        PayType: null,
        FeeOrderStatus: null
      }
      vm.timePayDTStart = undefined
      vm.timePayDTEnd = undefined
      vm.items = []
      vm.PostFeeorderQuerydetail()
    },
    CheckFeeorderCancel (data) { // 單筆確認作廢
      this.Cancel.Data = []
      var Odd = {}
      Odd.FeeOrderId = data
      this.Cancel.Data[0] = Odd
      $('#FeeorderCancel').modal('show')
    },
    CheckManyFeeorderCancel () { // 多筆確認作廢
      var AllData = []
      const vm = this
      if (vm.selected.length === 0) {
        vm.ErrorModal('請選擇需作廢的繳款項目。')
        return false
      } else {
        for (let index = 0; index < vm.selected.length; index++) {
          var Many = {}
          if (vm.selected[index].FeeOrderStatus !== 0) {
            vm.ErrorModal('繳款項目為未繳費狀態，才可進行作廢。')
            return false
          }
          Many.FeeOrderId = vm.selected[index].FeeOrderId
          AllData[index] = Many
        }
      }
      vm.Cancel.Data = AllData
      $('#FeeorderCancel').modal('show')
    },
    PostFeeorderCancel () { // 作廢 B_API 015
      // 定義資料
      const vm = this
      $('#FeeorderCancel').modal('hide')
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const NewData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), vm.Cancel)
      NewData.DeptId = UserData.DeptId
      // 呼叫API
      apiFeeorderCancel(NewData).then(
        res => {
          if (res !== undefined) {
            // 作廢的查詢條件 FeeOrderId 設為空值
            const ReceiptrQuery = JSON.parse(sessionStorage.getItem('ReceiptrQuery'))
            ReceiptrQuery.FeeOrderId = ''
            // 表格清空
            vm.items = []
            sessionStorage.setItem('ReceiptrQuery', JSON.stringify(ReceiptrQuery))
            vm.$bus.$emit('Modals', '作廢成功')
            $('#CheckOk').modal('show')
            vm.PostFeeorderQuerydetail()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderDetailexport () { // 統計報表匯出 B_API 025
      // 定義資料
      const vm = this
      const NewData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), vm.Querydetail)
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      // 判斷帳號身分
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
      }
      if (vm.Backend === true) {
        NewData.DeptId = vm.Querydetail.DeptId
      } else {
        NewData.DeptId = UserData.DeptId
      }
      // 呼叫API
      apiFeeorderDetailexport(NewData).then(
        res => {
          if (res !== undefined) {
            const Url = res.FileDir + '/' + res.FileName
            document.location.href = Url
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderRefundexport () { // 退費印領清冊匯出 B_API 026
      const vm = this
      for (let index = 0; index < vm.items.length; index++) {
        if (vm.items[index].FeeOrderStatus !== 4) {
          vm.ErrorModal('請確認資料繳費狀態為"已申請退費"')
          return false
        }
      }
      // 定義資料
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const NewData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), vm.Querydetail)
      // 判斷帳號身分
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
      }
      if (vm.Backend === true) {
        NewData.DeptId = vm.Querydetail.DeptId
      } else {
        NewData.DeptId = UserData.DeptId
      }
      // 呼叫API
      apiFeeorderRefundexport(NewData).then(
        res => {
          if (res !== undefined) {
            const Url = res.FileDir + '/' + res.FileName
            document.location.href = Url
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    Details (data) { // 導向詳細資料
      if (!data) {
        this.$bus.$emit('Modals', '尚無繳款項目編號')
        $('#CheckError').modal('show')
      } else {
        this.$router.push({ name: 'Admin_Payment_Receipt_Show', params: { id: data } })
      }
    },
    Refund (data) { // 導向退費頁面
      var check = ''
      if (data.RefundId === '') { // 判斷退費單號
        check = 'check'
      } else {
        check = data.RefundId
      }
      this.$router.push({ name: 'Admin_Refund_Application', params: { fid: data.FeeOrderId, rid: check } })
    },
    CheckQueryDept () { // 未查詢選擇部門時
      if (this.Querydetail.DeptId === '') {
        this.NewDeptId = ''
      }
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>
